module.exports = __webpack_public_path__ + "static/media/priority_med.bcebd000.svg";